import * as React from 'react';
import Model from './journalgroup-model';
import BasePicklist from '../base/base-picklist.component';

interface IProps { 
  currentId?: number;  
  onLoad?: (data: any) => void;
}

interface IState {
}

export default class JournalgroupPicklist extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  public render(): React.ReactNode {
    return (
      <BasePicklist endPointFilter={Model.endPointFilterList()} model={Model} currentId={this.props.currentId} onLoad={this.props.onLoad} disableBackButton/>
    );
  }
}
